import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["file", "cache", "remove", "saved", "selection", "image", "info", "status", "spinner"]

  connect() {
    this.initialCache = this.cacheTarget.value
    this.form = this.element.closest("form")
    this.onSubmit = () => {
      if (this.fileTarget.files.length || this.cacheTarget.value) {
        this.spinnerTarget.hidden = false
        this.statusTarget.textContent = "Загрузка обложки и создание уменьшенных версий…"
      }
    }
    this.onSubmitEnd = () => { this.spinnerTarget.hidden = true }
    this.form.addEventListener("submit", this.onSubmit)
    this.form.addEventListener("turbo:submit-end", this.onSubmitEnd)
  }

  disconnect() {
    this.releaseURL()
    this.form.removeEventListener("submit", this.onSubmit)
    this.form.removeEventListener("turbo:submit-end", this.onSubmitEnd)
  }

  preview() {
    this.releaseURL()
    const file = this.fileTarget.files[0]
    this.fileTarget.setCustomValidity("")
    if (!file) return this.clear()
    this.fileDescription = `${file.name} · ${this.formatSize(file.size)} · ${file.type || "неизвестный тип"}`
    this.infoTarget.textContent = this.fileDescription

    if (!["image/jpeg", "image/png", "image/webp"].includes(file.type) || file.size > 20 * 1024 * 1024) {
      const message = "Выберите JPG, PNG или WebP размером не более 20 МБ."
      this.fileTarget.setCustomValidity(message)
      this.selectionTarget.hidden = false
      this.imageTarget.hidden = true
      this.savedTarget.hidden = this.removeTarget.checked
      this.spinnerTarget.hidden = true
      this.statusTarget.textContent = message
      return
    }

    this.removeTarget.checked = false
    this.cacheTarget.value = ""
    this.savedTarget.hidden = true
    this.selectionTarget.hidden = false
    this.imageTarget.hidden = false
    this.spinnerTarget.hidden = false
    this.statusTarget.textContent = "Подготовка предпросмотра…"
    this.objectURL = URL.createObjectURL(file)
    this.imageTarget.src = this.objectURL
  }

  loaded() {
    if (!this.objectURL) return
    this.infoTarget.textContent = `${this.fileDescription} · ${this.imageTarget.naturalWidth} × ${this.imageTarget.naturalHeight} px`
    this.spinnerTarget.hidden = true
    this.statusTarget.textContent = "Файл выбран. Загрузка начнётся при сохранении настроек."
  }

  failed() {
    if (!this.objectURL) return
    const message = "Не удалось прочитать изображение. Выберите другой файл."
    this.fileTarget.setCustomValidity(message)
    this.spinnerTarget.hidden = true
    this.statusTarget.textContent = message
  }

  clear() {
    this.releaseURL()
    this.fileTarget.value = ""
    this.fileTarget.setCustomValidity("")
    this.cacheTarget.value = this.removeTarget.checked ? "" : this.initialCache
    this.selectionTarget.hidden = true
    this.savedTarget.hidden = this.removeTarget.checked
    this.spinnerTarget.hidden = true
    this.statusTarget.textContent = this.removeTarget.checked ? "Обложка будет удалена при сохранении настроек." : ""
  }

  remove() {
    if (this.removeTarget.checked) this.clear()
    else this.cacheTarget.value = this.initialCache
    this.savedTarget.hidden = this.removeTarget.checked
    this.statusTarget.textContent = this.removeTarget.checked ? "Обложка будет удалена при сохранении настроек." : ""
  }

  releaseURL() {
    if (this.objectURL) URL.revokeObjectURL(this.objectURL)
    this.objectURL = null
  }

  formatSize(bytes) {
    return bytes >= 1024 * 1024 ? `${(bytes / (1024 * 1024)).toFixed(2)} МБ` : `${(bytes / 1024).toFixed(1)} КБ`
  }
}
